import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {env} from "@environments/environment";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class SearchController {

  public constructor(httpService: HttpClient) {
    this.httpService = httpService;
  }

  httpService: HttpClient;
  protected baseUrl = `${env.logisticsServiceBackend}/logistics/v1/search`;

  public quickSearch(query: string): Observable<any>  {
    let params = new HttpParams();
    params = params.append("query", query);
    return this.httpService.get(`${this.baseUrl}/quick`, { params, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public search(query: string): Observable<any>  {
    let params = new HttpParams();
    params = params.append("query", query);
    return this.httpService.get(`${this.baseUrl}/full`, { params, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

}
